export default {
  modelValue: {
    type: Array,
    default: () => ([])
  },
  items: {
    type: Array,
    default: () => ([])
  },
  headers: {
    type: Array,
    required: true
  },
  itemHeight: {
    type: [Number, String],
    required: true
  },
  height: {
    type: Number,
    required: true
  },
  search: String,
  showSelect: {
    type: Boolean,
    default: false
  },
  colorShowSelect: {
    type: String,
    default: 'primary'
  },
  showExpand: {
    type: Boolean,
    default: false
  },
  showColumnCustom: {
    type: [Boolean, null],
    default: false,
  },
  idUniquePreference: {
    type: [String, null],
    required: false,
    default: null
  },
  disabledColumnsCustom: {
    type: [Array, null],
    required: false,
    default: null
  },
  singleExpand: {
    type: Boolean,
    default: false
  },
  itemKey: {
    type: String,
    default: 'index_of'
  },
  title: {
    type: String,
    required: false
  },
  iconTitle: {
    type: String,
    default: "mdi-format-list-bulleted"
  },
  fixedHeader: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean,
    default: false
  },
  noDataText: {
    type: String,
    default: 'Não há dados disponíveis'
  },
  noResultsText: {
    type: String,
    default: 'Nenhum dado encontrado'
  },
  hideDefaultFooter: {
    type: Boolean,
    default: false
  },
  hideDefaultHeader: {
    type: Boolean,
    default: false
  },
  itemClass: {
    type: [String, Function],
    default: '*'
  },
  classScroll: {
    type: String,
    default: ''
  },
  contentClass: {
    type: [String, Object],
    default: ''
  },
  disabledScrollVirtual: {
    type: Boolean,
    default: false
  },
  hideBorderBottomTr: {
    type: Boolean,
    default: false
  },
  ativar_ordenacao_manual: {
    type: Boolean,
    default: false
  },
  desativar_ordenacao: {
    type: Boolean,
    default: false
  },
  callbackFilterSearch: Function,
}
